export const ORDER_TYPE = {
  ASC: 'ASC',
  DESC: 'DESC'
}
